import { SearchProduct } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import { useFormatter } from 'next-intl';
import Image from 'next/image';

interface Props {
  product: SearchProduct;
}

export default function ProductListElement(props: Props) {
  const f = useFormatter();

  return (
    <div className="group flex gap-3 h-full flex-row">
      <div
        className="w-32 h-32 relative bg-white rounded-sm overflow-hidden shrink-0 py-2 border border-greyscale-separator shadow-[0_0_35px_0_rgba(135,135,135,0.1)]"
      >
        <Image
          fill
          className="object-contain transition ease-in-out duration-500 w-32 h-32"
          src={props.product.imageUrl ? props.product.imageUrl : ''}
          alt={props.product.name}
        />
      </div>
      <div className="flex-1 flex flex-col justify-between">
        <div className="space-y-0.5">
          <h3 className="text-base font-bold tracking-tight text-greyscale-body m-0 leading-5">
            {props.product.name}
          </h3>
          <p className="text-sm text-greyscale-label font-medium tracking-tight">
            {props.product.producer}
          </p>
          <p className="text-sm text-greyscale-placeholder font-medium tracking-tight">
            {props.product.country ? props.product.country.name : ''}
            {props.product.region ? `, ${props.product.region.name}` : ''}
          </p>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex flex-col text-base tracking-tight m-0 gap-0 leading-5">
            {!!props.product.discountedPrice && (
              <span className="text-sm line-through text-greyscale-label font-medium">
                {f.number(props.product.price, {
                  style: 'currency',
                  currency: 'EUR',
                })}
              </span>
            )}
            <span className="text-greyscale-body font-bold">
              {f.number(props.product.discountedPrice || props.product.price, {
                style: 'currency',
                currency: 'EUR',
              })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
